import { createLucideIcon } from "lucide-react";

export const JusticeScale = createLucideIcon(
    "",
    [
        [
            "path",
            {
                d: "M12 22H15",
                key: "1xo5u5",
            },
        ],
        [
            "path",
            {
                d: "M12 22H9",
                key: "1cv3n7",
            },
        ],
        [
            "path",
            {
                d: "M12 5V22",
                key: "19ew48",
            },
        ],
        [
            "path",
            {
                d: "M13.5 3.5C13.5 4.32843 12.8284 5 12 5C11.1716 5 10.5 4.32843 10.5 3.5C10.5 2.67157 11.1716 2 12 2C12.8284 2 13.5 2.67157 13.5 3.5Z",
                key: "1jnbym",
            },
        ],
        [
            "path",
            {
                d: "M18.5 17C19.8547 17 21.0344 16.1663 21.6473 14.9349C21.978 14.2702 22.1434 13.9379 21.8415 13.469C21.5396 13 21.04 13 20.0407 13H16.9593C15.96 13 15.4604 13 15.1585 13.469C14.8566 13.9379 15.022 14.2702 15.3527 14.9349C15.9656 16.1663 17.1453 17 18.5 17Z",
                key: "3fjf3b",
            },
        ],
        [
            "path",
            {
                d: "M21 13L18.5 8L16 13",
                key: "7ccpg9",
            },
        ],
        [
            "path",
            {
                d: "M4 8H5.0482C6.31166 8 7.5375 7.471 8.5241 6.5C10.5562 4.5 13.4438 4.5 15.4759 6.5C16.4625 7.471 17.6883 8 18.9518 8H20",
                key: "7fhmyn",
            },
        ],
        [
            "path",
            {
                d: "M5.5 17C6.85471 17 8.03442 16.1663 8.64726 14.9349C8.97802 14.2702 9.14339 13.9379 8.84151 13.469C8.53962 13 8.04 13 7.04075 13H3.95925C2.96 13 2.46038 13 2.15849 13.469C1.85661 13.9379 2.02198 14.2702 2.35273 14.9349C2.96558 16.1663 4.14528 17 5.5 17Z",
                key: "1nkj6o",
            },
        ],
        [
            "path",
            {
                d: "M8 13L5.5 8L3 13",
                key: "1hd4h2",
            },
        ],
    ],
);
